module.exports = __webpack_public_path__ + "static/media/flyingmoneyparrot.bab02fdc.gif";